import React from "react";
import moment from "moment";
import Patient from "../tables/Patient";
import Date from "../tables/Date";
import _ from "lodash";
import { Typography } from "antd";
const { Text } = Typography;

export const processChangedKeys = (selectedEvents, changedKeys) => {
  if (changedKeys && changedKeys.length > 0) {
    changedKeys.forEach((item) => {
      const filtered = selectedEvents.find((k) => k.id === item.old);
      if (filtered) {
        const arr = selectedEvents.filter((j) => j.id !== filtered.id);
        selectedEvents = [...arr, { ...filtered, id: item.new }];
      }
    });
  }
  return selectedEvents;
};

export const dispatchActionEvents = async (
  dispatch,
  patientId,
  branchId,
  selectedEvents,
  actionEvents,
  val
) => {
  const params = {
    patientId: patientId,
    branchId: branchId,
    events:
      val === undefined
        ? { events: selectedEvents.map((i) => i.id) }
        : {
            events: selectedEvents.map((i) => {
              return {
                id: i.id,
                approved: val,
              };
            }),
          },
  };
  return await dispatch(actionEvents(params));
};

export const onAction = async (
  actionEvents,
  items,
  selectedRowKeys,
  fromEmployee,
  patientId,
  branchId,
  dispatch,
  reload,
  setSelectedRowKeys,
  setChangedEvents,
  changedKeys,
  filterFunc
) => {
  let selectedEvents = items
    .filter((k) => selectedRowKeys.includes(k.id) && filterFunc(k))
    .map((i) => ({
      patientId: fromEmployee && i.order.patient_id,
      branchId: fromEmployee && i.order.patient.branch,
      id: i.id,
    }));

  if (selectedEvents.length > 0) {
    if (fromEmployee) {
      const grouped = _.groupBy(selectedEvents, "patientId");
      const promises = Object.keys(grouped).map(async (key) => {
        let toProcess = selectedEvents.filter((e) => +e.patientId === +key);
        toProcess = processChangedKeys(toProcess, changedKeys);

        let update = null;
        if (toProcess.length > 0) {
          update = await dispatchActionEvents(
            dispatch,
            toProcess[0].patientId,
            toProcess[0].branchId,
            toProcess,
            actionEvents
          );
        }
        return update;
      });

      const action = await Promise.all(promises);
      if (
        action &&
        action[0] &&
        action[0].payload &&
        action[0].payload.status === "ok"
      ) {
        reload();
        setSelectedRowKeys([]);
        setChangedEvents([]);
      }
    } else {
      selectedEvents = processChangedKeys(selectedEvents, changedKeys);
      const action = await dispatchActionEvents(
        dispatch,
        patientId,
        branchId,
        selectedEvents,
        actionEvents
      );

      if (!action.error) {
        reload();
        setSelectedRowKeys([]);
        setChangedEvents([]);
      }
    }
  }
};

export const onApprove = async (
  items,
  selectedRowKeys,
  fromEmployee,
  patientId,
  branchId,
  dispatch,
  approveEvent,
  reload,
  setSelectedRowKeys,
  setChangedEvents,
  changedKeys,
  filterFunc,
  val
) => {
  let selectedEvents = items
    .filter((k) => selectedRowKeys.includes(k.id) && filterFunc(k))
    .map((i) => ({
      patientId: fromEmployee && i.order.patient_id,
      branchId: fromEmployee && i.order.patient.branch,
      approved: val,
      id: i.id,
    }));

  if (selectedEvents.length > 0) {
    if (fromEmployee) {
      const grouped = _.groupBy(selectedEvents, "patientId");
      const promises = Object.keys(grouped).map(async (key) => {
        let changed = selectedEvents.filter((e) => +e.patientId === +key);
        changed = processChangedKeys(changed, changedKeys);

        let update = null;
        if (changed.length > 0) {
          update = await dispatchActionEvents(
            dispatch,
            changed[0].patientId,
            changed[0].branchId,
            changed,
            approveEvent,
            val
          );
        }
        return update;
      });

      await Promise.all(promises);
    } else {
      selectedEvents = processChangedKeys(selectedEvents, changedKeys);
      await dispatchActionEvents(
        dispatch,
        patientId,
        branchId,
        selectedEvents,
        approveEvent,
        val
      );
    }

    reload();
    setSelectedRowKeys([]);
    setChangedEvents([]);
  }
};

export const getMatchingConflictsColumns = (intl, type) => {
  return type === "plan"
    ? [
        {
          title: intl.formatMessage({
            id: "app.scheduling.table.schedulingPatientName",
          }),
          dataIndex: "patient",
          render: (text, record) => {
            return text ? <Patient record={text} /> : null;
          },
          width: "220px",
        },
        {
          title: intl.formatMessage({
            id: "app.scheduling.table.schedulingDayInWeek",
          }),
          dataIndex: "weekday",
          render: (text, record) => {
            return <Text>{moment.weekdays(text)}</Text>;
          },
          width: "100px",
        },
        {
          title: intl.formatMessage({
            id: "app.scheduling.table.schedulingStartHour",
          }),
          dataIndex: "start_time_minutes",
          render: (text) => {
            const startTime = moment().startOf("day").add(text, "minutes");
            return <Date text={startTime} format="HH:mm" />;
          },
          width: "100px",
        },
        {
          title: intl.formatMessage({
            id: "app.scheduling.table.schedulingEndHour",
          }),
          dataIndex: "duration_minutes",
          width: "100px",
          render: (text, record) => {
            const endTime = moment()
              .startOf("day")
              .add(record.start_time_minutes + text, "minutes");
            return <Date text={endTime} format="HH:mm" />;
          },
        },
      ]
    : [
        {
          title: intl.formatMessage({
            id: "app.scheduling.table.schedulingPatientName",
          }),
          dataIndex: "patient",
          render: (text, record) => {
            return text ? <Patient record={text} /> : null;
          },
          width: "220px",
        },
        {
          title: intl.formatMessage({
            id: "app.scheduling.table.schedulingDayInWeek",
          }),
          dataIndex: "date",
          render: (text, record) => {
            return <Text>{moment.weekdays(moment(text).weekday())}</Text>;
          },
          width: "100px",
        },
        {
          title: intl.formatMessage({
            id: "app.scheduling.table.schedulingStartHour",
          }),
          dataIndex: "date",
          render: (text, record) => {
            const date = record?.ok2go_info?.id
              ? record?.ok2go_info?.date
              : text;
            return date && <Date text={date} format="HH:mm" />;
          },
          width: "100px",
        },
        {
          title: intl.formatMessage({
            id: "app.scheduling.table.schedulingEndHour",
          }),
          dataIndex: "date",
          width: "100px",
          render: (text, record) => {
            const endTime = record?.ok2go_info?.id
              ? record?.ok2go_info?.exit_date
              : moment(text).add(record.duration_minutes, "minutes");
            return endTime && <Date text={endTime} format="HH:mm" />;
          },
        },
      ];
};
